import VueRouter from 'vue-router'
import Admin from './admin'
import Users from './users'
import Auth from '@/auth'

export function createRouter() {
  const defaultRoutes = [
    {
      path: '/',
      redirect: '/admin'
    }
  ]

  const router = new VueRouter({
    mode: 'history',
    scrollBehavior: (to, from, savedPosition) => {
      return savedPosition || { y: 0, x: 0 }
    },
    routes: [...defaultRoutes, ...Users, ...Admin]
  })

  router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
      if (!Auth.isLoggedIn()) {
        return next({
          path: '/login',
          query: { redirect: to.fullPath }
        })
      }
    }

    return next()
  })

  return router
}

export default createRouter()
